import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
// import SignupForm from './components/SignupForm';
import LoginForm from './components/LoginForm';
import UploadPage from './components/UploadPage';
import HistoryPage from './components/HistoryPage'
import { ToastContainer } from 'react-toastify';  

function App() {
  return (
    <Router>
        <Routes>
          {/* <Route path="/signup" element={<SignupForm />} /> */}
          <Route path="/login" element={<LoginForm />} />
          <Route path="/upload" element={<UploadPage/>}/>
          <Route path="/" element={<LoginForm />} />
          <Route path="/history" element={<HistoryPage />} />
        </Routes>
        <ToastContainer />
    </Router>
  );
}

export default App;
